<div class="row justify-content-sm-center" *ngIf="isLoggedIn">
    <div class="col text-center">
        <h3>Welcome {{authService.user.username}}!</h3>
    </div>

    <!--<div class="col-sm-3" style="margin-top: 10px;">
        <button class="btn btn-secondary" (click)="logout()">Logout</button>
    </div>-->
</div>

<div class="row justify-content-sm-center">
    <div class="col-sm-4">
        <kendo-expansionpanel [title]="'Order Lookup'"
                              [subtitle]="''"
                              [expanded]="true">
            <label for="quoteOrderID" style="margin-right: 5px; width: 125px;">Order # </label>
            <input id="quoteOrderID" type="text" (keyup.enter)="searchQuoteOrder(false)" [(ngModel)]="quoteOrderID" />
            <button class="btn btn-primary m-2" (click)="searchQuoteOrder(false)">Search</button>

            <br />

            <label for="externalOrderNumber" style="margin-right: 5px; width: 125px;">Ext. Order # </label>
            <input id="externalOrderNumber" type="text" (keyup.enter)="searchExternalOrder(false)" [(ngModel)]="externalOrderNumber" />
            <i class="fas fa-arrow-circle-down fa-lg text-secondary m-1" style="cursor:pointer" title="Sync Order" (click)="syncOrder()" *ngIf="isShowSyncButton && externalOrderNumber != ''"></i>
            <button class="btn btn-primary m-2" (click)="searchExternalOrder(false)">Search</button>
        </kendo-expansionpanel>
    </div>

    <div class="col-sm-4">
        <kendo-expansionpanel [title]="'Customer Lookup'"
                              [subtitle]="''"
                              [expanded]="true">
            <!--<label style="margin-right: 5px; width: 125px;">Customer Search: </label>
    <input type="text" (keyup.enter)="searchCustomerCode()" [(ngModel)]="customerCode" />
    <button class="btn btn-primary m-2" (click)="searchCustomerCode()">Search</button>-->
            <div class="row">
                <div class="col">
                    <customer-dropdown [parentForm]="customerFormGroup" [ctrlName]="'customerCtrl'" [placeholder]="'Enter Code'"
                                       [lookupType]="'customer'" (customerSelected)="onCustomerChange($event, 'customerCtrl')"></customer-dropdown>
                </div>
            </div>
            <div class="row" *ngIf="(searchCustomer | json) != '{}'">
                <div class="col">
                    <a target="_blank" [routerLink]="['/customer-detail', searchCustomer.customerCode]" tabindex="-1">{{searchCustomer.customerName}}</a><br />
                    <a target="_blank" [routerLink]="['/customer-detail', searchCustomer.customerCode]" tabindex="-1">{{searchCustomer.customerCode}}</a><br />
                    {{searchCustomer.address1}}<br />
                    {{searchCustomer.cityStateZip}}<br />
                    <i class="fas fa-globe"></i> {{searchCustomer.timeZoneName}}
                </div>
                <div class="col-sm-2">
                    <a target="_blank" href="{{showMapPoint(searchCustomer.latitude,searchCustomer.longitude)}}"
                       class="text-danger h2" title="Show on Map" tabindex="-1"
                       *ngIf="searchCustomer.latitude!=null&&searchCustomer.longitude!=null">
                        <i class="fas fa-map-marker-alt"></i>
                    </a>
                </div>
            </div>
        </kendo-expansionpanel>
    </div>
</div>

<div class="row justify-content-sm-center">
    <div class="col-sm-8">
        <kendo-expansionpanel [title]="'Carrier Lookup'"
                              [subtitle]="''"
                              [expanded]="true">
            <!--<div>
        <label style="margin-right: 5px; width: 125px;">Carrier Search: </label>
        <input type="text" (keyup.enter)="searchCarrier()" [(ngModel)]="carrierSearch" />
        <button class="btn btn-primary m-2" (click)="searchCarrier()">Search</button>
    </div>-->
            <div class="row">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-sm-2">
                            <label class="font-weight-bold">MC</label>
                        </div>
                        <div class="col-sm-6">
                            <carrier-dropdown [parentForm]="carrierFormGroup" [ctrlName]="'carrierLookupMCControl'" [placeholder]="'Enter MC'"
                                              [carrierLookupType]="'MC'" (carrierSelected)="onCarrierChange($event, 'MC')"></carrier-dropdown>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <label class="font-weight-bold">Code</label>
                        </div>
                        <div class="col-sm-6">
                            <carrier-dropdown [parentForm]="carrierFormGroup" [ctrlName]="'carrierLookupCodeControl'" [placeholder]="'Enter Code'"
                                              [carrierLookupType]="'Code'" (carrierSelected)="onCarrierChange($event, 'Code')"></carrier-dropdown>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <label class="font-weight-bold">Name</label>
                        </div>
                        <div class="col-sm-6">
                            <carrier-dropdown [parentForm]="carrierFormGroup" [ctrlName]="'carrierLookupNameControl'" [placeholder]="'Enter Name'"
                                              [carrierLookupType]="'Name'" (carrierSelected)="onCarrierChange($event, 'Name')"></carrier-dropdown>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <label class="font-weight-bold">DOT</label>
                        </div>
                        <div class="col-sm-6">
                            <carrier-dropdown [parentForm]="carrierFormGroup" [ctrlName]="'carrierLookupDOTControl'" [placeholder]="'Enter DOT'"
                                              [carrierLookupType]="'DOT'" (carrierSelected)="onCarrierChange($event, 'DOT')"></carrier-dropdown>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <label class="font-weight-bold">MX</label>
                        </div>
                        <div class="col-sm-6">
                            <carrier-dropdown [parentForm]="carrierFormGroup" [ctrlName]="'carrierLookupMXControl'" [placeholder]="'Enter MX'"
                                              [carrierLookupType]="'MX'" (carrierSelected)="onCarrierChange($event, 'MX')"></carrier-dropdown>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <label class="font-weight-bold">SCAC</label>
                        </div>
                        <div class="col-sm-6">
                            <carrier-dropdown [parentForm]="carrierFormGroup" [ctrlName]="'carrierLookupSCACControl'" [placeholder]="'Enter SCAC'"
                                              [carrierLookupType]="'SCAC'" (carrierSelected)="onCarrierChange($event, 'SCAC')"></carrier-dropdown>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6" *ngIf="(carrier | json) != '{}'">
                    <div class="row p-1">
                        <div class="col-sm-3 font-weight-bold text-end">Carrier</div>
                        <div class="col">
                            <a target="_blank" [routerLink]="['/carrier-detail', carrier.carrierCode]">
                                {{carrier.carrierCode}}
                            </a><br />
                            <a target="_blank" [routerLink]="['/carrier-detail', carrier.carrierCode]">
                                {{carrier.carrierName}}
                            </a><br />
                            {{carrier.carrierCity}}, {{carrier.carrierState}}
                        </div>
                    </div>
                    <div class="row p-1" *ngIf="carrier.mcNumber&&carrier.mcNumber.startsWith('MC')">
                        <div class="col-sm-3 font-weight-bold text-end">MC</div>
                        <div class="col">
                            {{carrier.mcNumber}}
                        </div>
                    </div>
                    <div class="row p-1" *ngIf="carrier.dotNumber!=null">
                        <div class="col-sm-3 font-weight-bold text-end">DOT</div>
                        <div class="col">
                            {{carrier.dotNumber}}
                        </div>
                    </div>
                    <div class="row p-1" *ngIf="carrier.mcNumber&&carrier.mcNumber.startsWith('MX')">
                        <div class="col-sm-3 font-weight-bold text-end">MX</div>
                        <div class="col">
                            {{carrier.mcNumber}}
                        </div>
                    </div>
                    <div class="row p-1" *ngIf="carrier.scacNumber!=null&&carrier.scacNumber!=''">
                        <div class="col-sm-3 font-weight-bold text-end">SCAC</div>
                        <div class="col">
                            {{carrier.scacNumber}}
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-sm-3 font-weight-bold text-end">Team</div>
                        <div class="col">
                            <ul>
                                <li *ngFor="let emp of carrierTeamList">{{emp.carrierTeamTypeAbbreviation}}: {{emp.employeeName}}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-sm-3 font-weight-bold text-end">Incidents</div>
                        <div class="col">
                            {{carrier.carrierIncidents}}
                        </div>
                    </div>
                    <div class="row p-1" *ngIf="carrier.carrierIncidents > 0">
                        <div class="col-sm-3 font-weight-bold text-end">Last Incident</div>
                        <div class="col">
                            {{carrier.lastCarrierIncidentDate | date:'shortDate'}}
                        </div>
                    </div>
                </div>
            </div>
        </kendo-expansionpanel>
    </div>
</div>

<div class="row justify-content-sm-center" *showRolesIf="'Record Lock Admin'">
    <div class="col-sm-8">
        <kendo-expansionpanel [title]="'Order Record Lock Lookup'"
                              [subtitle]="''"
                              [expanded]="true">
            <div class="row">
                <div class="col-sm-6">
                    <label for="lockQuoteOrderID" style="margin-right: 5px; width: 125px;">Order # </label>
                    <input id="lockQuoteOrderID" type="text" (keyup.enter)="searchQuoteOrder(true)" [(ngModel)]="quoteOrderID" />
                    <button class="btn btn-primary m-2" (click)="searchQuoteOrder(true)">Search</button>

                    <br />

                    <label for="lockExternalOrderNumber" style="margin-right: 5px; width: 125px;">Ext. Order # </label>
                    <input id="lockExternalOrderNumber" type="text" (keyup.enter)="searchExternalOrder(true)" [(ngModel)]="externalOrderNumber" />
                    <button class="btn btn-primary m-2" (click)="searchExternalOrder(true)">Search</button>
                </div>
                <div class="col-sm-6" *ngIf="(searchRecordLock | json) != '{}'">
                    <h3>Edits for this Order are currently locked.</h3>
                    <div><b>Locked By:</b> {{searchRecordLock.checkedOutByEmployeeName}}</div>
                    <div><b>Date Locked:</b> {{utilService.getTimeZoneDateAsLocalDate(searchRecordLock.dateCheckedOut, "UTC") | date:'medium'}}</div>
                    <div><b>Lock Type:</b> {{searchRecordLock.recordLockTypeName}}</div>
                    <div><b>Lock Source:</b> {{searchRecordLock.lockSource}}</div>
                    <div class="float-right">
                        <button class="btn btn-danger" (click)="overrideLock()">Override Lock</button>
                        <button class="btn btn-primary m-2" (click)="cancelOverride()">Cancel</button>
                    </div>
                </div>
            </div>
        </kendo-expansionpanel>
    </div>
</div>

<!--<div class="col-sm-12">
    <button (click)="testGraph()">Test</button>
</div>-->
